import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  paper: {
    minWidth: "600px",
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
    },
  },
  subtitle: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
  explanation: {
    marginBottom: theme.spacing(3),
  },
  codeBox: {
    backgroundColor: "rgb(226, 231, 239,0.3)",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: "10px",
  },
  code: {
    fontSize: "1.6rem",
    fontFamily: "monoespace",
  },
  copyButton: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  closeButton: {
    marginBottom: theme.spacing(2),
  },
}))

export default styles
